// Header del AdminDashboard
// Incluye: título, toggle activas/archivadas, botón analíticas, botón nueva propiedad

import React from 'react';
import { Building2, Plus, Archive, Eye, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Header del panel de administración
 * 
 * @param {boolean} showArchived - Si está en modo archivadas
 * @param {function} onToggleArchived - Toggle entre activas/archivadas
 * @param {function} onGoToEngagement - Navegación a analíticas
 * @param {function} onCreateProperty - Abrir modal de crear propiedad
 * @param {boolean} saving - Si hay operación en curso
 * @param {boolean} loadingArchived - Si está cargando archivadas
 * @param {boolean} hasProperties - Si hay propiedades (activas o archivadas)
 */
const AdminHeader = ({ 
  showArchived,
  onToggleArchived,
  onCreateProperty,
  saving = false,
  loadingArchived = false,
  hasProperties = false
}) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="mb-8">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        {/* Lado izquierdo: Logo y título */}
        <div className="flex items-center gap-3">
          <div className="bg-gradient-to-br from-amber-400 to-amber-600 p-3 rounded-xl">
            <Building2 className="w-6 h-6 text-slate-900" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-white">Panel de Administración</h1>
            <p className="text-slate-400">Gestiona tus propiedades y ofertas</p>
          </div>
        </div>

        {/* Lado derecho: Botones de acción */}
        <div className="flex flex-wrap items-center gap-3">
          {/* Botón Nueva Propiedad - Siempre visible, deshabilitado en archivadas */}
          <button
            onClick={showArchived ? undefined : onCreateProperty}
            disabled={showArchived || saving}
            className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all ${
              showArchived
                ? 'bg-amber-500/30 text-slate-500 cursor-not-allowed'
                : 'bg-gradient-to-r from-amber-500 to-amber-600 text-slate-900 hover:from-amber-600 hover:to-amber-700 disabled:opacity-50 disabled:cursor-not-allowed'
            }`}
          >
            <Plus className="w-5 h-5" />
            Nueva Propiedad
          </button>

          {/* Toggle Activas/Archivadas - Ancho mínimo fijo */}
          <button
            onClick={onToggleArchived}
            disabled={loadingArchived}
            style={{ minWidth: '169px' }}
            className={`flex items-center justify-center gap-2 px-4 py-3 rounded-lg font-medium transition-all ${
              showArchived
                ? 'bg-amber-500/20 text-amber-400 border border-amber-500/30'
                : 'bg-slate-700/50 text-slate-300 border border-slate-600/50 hover:bg-slate-700'
            } disabled:opacity-50`}
          >
            {showArchived ? (
              <>
                <Eye className="w-5 h-5" />
                <span>Ver Activas</span>
              </>
            ) : (
              <>
                <Archive className="w-5 h-5" />
                <span>Ver Archivadas</span>
              </>
            )}
          </button>

          {/* Botón Salir */}
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-3 rounded-lg font-medium transition-all bg-red-500/20 text-red-400 border border-red-500/30 hover:bg-red-500/30"
          >
            <LogOut className="w-5 h-5" />
            Salir
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;